import {Injectable} from '@angular/core';
import {ExamenDefinitionSummaryModel} from "../../../api/entity/ExamenDefinitionSummary.model";
import {ExamenDefinitionSummaryConverter} from "../../../api/entity/converter/examenDefinitionSummary.converter";
import {ExamenDefinitionModel} from "../../../api/entity/examenDefinition.model";
import {ExamenDefinitionDataService} from "./examenDefinitionData.service";
import {AbstractDataServiceDtoSummaryAdapter} from "../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter";

@Injectable()
export class ExamenDefinitionSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<ExamenDefinitionSummaryModel, ExamenDefinitionSummaryConverter, ExamenDefinitionModel> {
    constructor(dataService: ExamenDefinitionDataService, converter: ExamenDefinitionSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ExamenDefinitionModel {
        return new ExamenDefinitionModel();
    }


}
